import { createSelector } from '@reduxjs/toolkit'

interface AuthMeState {
	id: string
	email: string
	username: string
	admin: boolean
	isFetching: boolean
	failedGet: boolean
	loggedIn: boolean
	[key: string]: unknown
}

interface AuthRootState {
	auth?: {
		me?: Partial<AuthMeState>
	}
}

const selectMe = (state: Record<string, unknown>): Partial<AuthMeState> | undefined => {
	return (state as AuthRootState).auth?.me
}

const defaultMeState: AuthMeState = {
	id: null as unknown as string,
	email: '',
	username: '',
	admin: false,
	isFetching: false,
	failedGet: false,
	loggedIn: false,
}

export const me = createSelector(selectMe, (currentMe) => ({ me: { ...defaultMeState, ...(currentMe ?? {}) } }))

export const loggedIn = createSelector(selectMe, (currentMe) => ({ loggedIn: Boolean((currentMe ?? {}).loggedIn) }))
